import { render } from "./alterStatusLotInMassComponent.vue?vue&type=template&id=204e3ae8"
import script from "./alterStatusLotInMassComponent.vue?vue&type=script&lang=js"
export * from "./alterStatusLotInMassComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__